import { InventoryArea } from '../Area/inventoryArea';

export class TaskResponsiblePerson {
    userId: string;
    email: string;
    name: string;
    number: string;
    areas: InventoryArea[] = [];
}